// frontend/app/src/features/feedback/ui/FeedbackModal.jsx
import React, { useState } from 'react';
import { BaseModal } from '@shared/ui/Modal';
import BugReportForm from './forms/BugReportForm';
import SuggestionForm from './forms/SuggestionForm';
import ApplicationForm from './forms/ApplicationForm';
import './FeedbackModal.css';

const FeedbackModal = ({ show, onClose }) => {
  const [activeTab, setActiveTab] = useState('bug');

  const handleSuccess = () => {
    setTimeout(onClose, 2000);
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title="ОБРАТНАЯ СВЯЗЬ"
      width="800px"
      showConfirm={false}
    >
      <div className="feedback-modal-content">
        <div className="feedback-tabs">
          <button
            className={`feedback-tab-btn ${activeTab === 'bug' ? 'active' : ''}`}
            onClick={() => setActiveTab('bug')}
          >
            БАГ-РЕПОРТ
          </button>
          <button
            className={`feedback-tab-btn ${activeTab === 'idea' ? 'active' : ''}`}
            onClick={() => setActiveTab('idea')}
          >
            ИДЕИ
          </button>
          <button
            className={`feedback-tab-btn ${activeTab === 'apply' ? 'active' : ''}`}
            onClick={() => setActiveTab('apply')}
          >
            ЗАЯВКИ
          </button>
        </div>

        <div className="feedback-form-container">
          {activeTab === 'bug' && <BugReportForm onSuccess={handleSuccess} />}
          {activeTab === 'idea' && <SuggestionForm onSuccess={handleSuccess} />}
          {activeTab === 'apply' && <ApplicationForm onSuccess={handleSuccess} />}
        </div>
      </div>
    </BaseModal>
  );
};

export default FeedbackModal;
